import React, { PropsWithChildren } from 'react';
import { Tag } from './styles';
import ProfileCardPopper from '@/components/@IntranetLibrary/ProfileCard/ProfileCardPopper';
import usePopper from '@/hooks/usePopper';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import classNames from 'classnames';
import { Body2 } from '@/components/@IntranetLibrary/Typography';

const Mention: React.FC<
  PropsWithChildren<{ id: string; isText?: boolean }>
> = ({ id: passportId, isText = false, children }) => {
  const { passportId: myPassportId } = useAtomValue(MyInfoState);
  const { anchorEl, openPopper, closePopper } = usePopper<HTMLButtonElement>();

  return (
    <>
      {isText ? (
        <Body2
          sx={{ display: 'inline-block', color: 'var(--dk-text, #000)', padding: '2px 4px' }}
        >
          {children}
        </Body2>
      ) : (
        <>
          <Tag
            onClick={openPopper}
            className={classNames({ isAuthor: myPassportId === passportId })}
          >
            {children}
          </Tag>
          <ProfileCardPopper
            passportId={passportId}
            anchorEl={anchorEl}
            onClose={closePopper}
          />
        </>
      )}
    </>
  );
};

export default Mention;
